import uuid from "uuid4";
import { debugLogTime } from "../utils/common";

const dispatch = (event, data) => {
  debugLogTime("EventEmitter.dispatch", event, "EventEmitter");
  if (!EventEmitter.events[event]) {
    return;
  }
  debugLogTime("EventEmitter.dispatch", data, "EventEmitter");
  const eventKeys = Object.keys(EventEmitter.events[event]);
  eventKeys.forEach((key) => EventEmitter.events[event][key](data));
};

const subscribe = (event, callback) => {
  debugLogTime("EventEmitter.subscribe", event, "EventEmitter");

  if (!EventEmitter.events[event]) {
    EventEmitter.events[event] = {};
  }
  const id = uuid();
  EventEmitter.events[event][id] = callback;
  return id;
};

const unsubscribe = (event, id) => {
  debugLogTime("EventEmitter.unsubscribe", event, "EventEmitter");
  if (EventEmitter.events[event]) {
    delete EventEmitter.events[event][id];
  }
};

const EventEmitter = (function () {
  return {
    events: {},
    dispatch,
    subscribe,
    unsubscribe,
  };
})();

export { EventEmitter };
